import { render, staticRenderFns } from "./lesson-dialog.vue?vue&type=template&id=4895e5b7"
import script from "./lesson-dialog.vue?vue&type=script&lang=ts"
export * from "./lesson-dialog.vue?vue&type=script&lang=ts"
import style0 from "./lesson-dialog.vue?vue&type=style&index=0&id=4895e5b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports